<app-header header="PRODUCT_LIST.TITLE_PRODUCTS_LIST"></app-header>
<div class="page" [ngClass.gt-sm]="{ 'desktop': true }">

  <!-- title and search/filter -->
  <div fxHide fxShow.gt-sm>

    <div class="title" fxHide fxShow.gt-sm>

      <!-- Navigation breadcrumbs -->
      <nav id="breadcrumb">
        <ol class="breadcrumbs">
          <li class="breadcrumbs-item">
            <a [routerLink]="['..', '..']" class="breadcrumbs-link">{{ 'PRODUCT_LIST.ACTION_BREADCRUMB_TERMINALS' | translate }}</a>
          </li>
          <li class="breadcrumbs-item">
            <a class="breadcrumbs-link breadcrumbs-link-active">{{ 'PRODUCT_LIST.TITLE_PRODUCTS_LIST' | translate }}</a>
          </li>
        </ol>
      </nav>

      <div class="actions">
        <a mat-button (click)="$expandAllToggle.next()">{{ 'PRODUCT_LIST.ACTION_TOGGLE_BUTTON' | translate }}</a>
      </div>

    </div>

    <!-- Show desktop filter -->
    <app-filter (goBack)="goBack()"></app-filter>
  </div>

  <!-- products -->
  <app-product-list [expandAll$]="expandAll$" [products$]="products$" [loading$]="productApiService.loading$" [refreshing$]="productApiService.refreshing$">
  </app-product-list>

  <!-- title and search/filter for mobile -->
  <app-footer (goBack)="goBack()">
    <app-filter></app-filter>
  </app-footer>

</div>
